import { defineStore } from "pinia"
import { Role } from "@/services/PermissionsService"

export interface IMockPermissions {
  enabled: boolean
  roles: Role[]
}

export const useMockPermissionsStore = defineStore("mockPermissions", {
  state: (): IMockPermissions => {
    return {
      enabled: false,
      roles: [],
    }
  },
})
